import { Routes } from '@angular/router';
import { AuthGuard } from './auth/guard/auth.guard';
import { OperationsGuard } from './auth/guard/operations.guard';
import { OperationsComponent } from './components/pages/operations/operations.component';
import { PersonsComponent } from './components/pages/persons/persons.component';
import { TreemapComponent } from './components/pages/treemap/treemap.component';
import { VehiclesComponent } from './components/pages/vehicles/vehicles.component';
import { AllDataTableComponent } from './components/pages/all-data/all-data-table/all-data-table.component';
import { ReportDetailsComponent } from './components/pages/operations/report-details/report-details.component';
import { TotalsComponent } from './components/pages/totals/totals.component';
import { TotalsGuard } from './auth/guard/totals.guard';
import { NoAccessComponent } from './components/pages/no-access/no-access.component';

const routes: Routes = [
  { path: '', redirectTo: '/map', pathMatch: 'full' },
  {
    path: 'map',
    loadComponent: () => import('./components/pages/map/map.component').then((m) => m.MapComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'analytic',
    children: [
      {
        path: 'citations',
        loadComponent: () =>
          import('./components/pages/citations/citations.component').then((m) => m.CitationsComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'persons',
        component: PersonsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'vehicles',
        component: VehiclesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'tree-map',
        component: TreemapComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'operations',
        component: OperationsComponent,
        canActivate: [AuthGuard, OperationsGuard],
      },
      {
        path: 'operations/report-details/:id',
        component: ReportDetailsComponent,
        canActivate: [AuthGuard, OperationsGuard],
      },
    ],
  },
  {
    path: 'base',
    component: AllDataTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'totals',
    component: TotalsComponent,
    canActivate: [AuthGuard, TotalsGuard],
  },
  {
    path: 'access-denied',
    component: NoAccessComponent,
  },
];

export default routes;
